/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { rateLimitStore } from './rateLimitStore';

/**
 * Reports that a request was rate limited, raising the standard notice.
 *
 * This is the bring-your-own-detection path, for services that spot a 429
 * themselves rather than through `registerRateLimitInterceptor` — the ticket and
 * timed-entry services fetch availability through rxjs `ajax`, and search uses
 * raw `fetch`. Call it from the error handling you already have; there is no
 * state to plumb and no modal to place.
 *
 * Pass the wait time the server asked for when there is one. Use
 * `parseRetryAfterMs` to read it out of a `retry-after` header rather than
 * hand-rolling RFC 9110 date parsing:
 *
 * ```ts
 * reportRateLimit(parseRetryAfterMs(response.headers.get('retry-after')));
 * ```
 *
 * A burst of rate-limited requests can call this many times over; the user still
 * sees one notice.
 */
export function reportRateLimit(retryAfterMs: number | null = null) {
    rateLimitStore.trigger(retryAfterMs);
}
